import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">About Afriq Global</h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
              Empowering businesses and individuals with modern digital solutions and world-class travel services
            </p>
          </div>
        </div>
      </section>

      {/* Company Profile */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/b04dd373975b4f334f47163c08048e57.jpg"
                alt="Afriq Global Office"
                className="w-full h-full object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Who We Are</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                <strong className="text-blue-700">Afriq Global</strong> is a Dubai Mainland company that empowers businesses and individuals with modern digital solutions and world-class travel services. We are a dynamic and innovative company committed to delivering excellence in everything we do.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Afriq Global has grown into a trusted partner for businesses seeking digital transformation and individuals looking for seamless travel experiences. Our dual focus on digital marketing and travel logistics makes us unique in the market.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Based in Dubai, UAE, we leverage our deep understanding of the local market and international standards to deliver services that exceed expectations. Our team of skilled professionals is dedicated to helping you achieve your goals through innovation, creativity, and exceptional service.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Mission */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                <i className="ri-rocket-fill text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-gray-700 leading-relaxed">
                To empower businesses and individuals with innovative digital solutions and seamless travel experiences that drive growth, enhance efficiency, and create lasting value in an ever-evolving global marketplace.
              </p>
            </div>

            {/* Vision */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-yellow-100 rounded-full mb-6">
                <i className="ri-eye-fill text-3xl text-yellow-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              <p className="text-gray-700 leading-relaxed">
                To become the leading provider of integrated digital and travel solutions in the region, recognized for our commitment to excellence, innovation, and client satisfaction. We envision a future where businesses thrive and travelers explore with confidence.
              </p>
            </div>

            {/* Values */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                <i className="ri-heart-fill text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Values</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-700 mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                  <span><strong>Excellence:</strong> We strive for the highest quality in everything we do</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-700 mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                  <span><strong>Innovation:</strong> We embrace creativity and forward-thinking solutions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-700 mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                  <span><strong>Integrity:</strong> We operate with transparency and honesty</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-700 mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                  <span><strong>Client Focus:</strong> Your success is our priority</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Innovation & Client-Focused Approach */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-gradient-to-br from-blue-700 to-blue-900 p-10 rounded-2xl text-white">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mb-6">
                <i className="ri-lightbulb-flash-fill text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4">Innovation Mindset</h3>
              <p className="text-lg leading-relaxed mb-6">
                At Afriq Global, innovation is at the core of everything we do. We constantly explore new technologies, strategies, and approaches to deliver cutting-edge solutions that keep our clients ahead of the competition.
              </p>
              <p className="text-lg leading-relaxed">
                From leveraging the latest digital marketing tools to implementing efficient travel logistics systems, we ensure that our services are always at the forefront of industry trends and best practices.
              </p>
            </div>

            <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 p-10 rounded-2xl text-black">
              <div className="w-16 h-16 flex items-center justify-center bg-black/20 rounded-full mb-6">
                <i className="ri-user-heart-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4">Client-Focused Approach</h3>
              <p className="text-lg leading-relaxed mb-6">
                Your success is our success. We take the time to understand your unique needs, challenges, and goals, crafting personalized solutions that deliver measurable results and exceed expectations.
              </p>
              <p className="text-lg leading-relaxed">
                Our dedicated team works closely with you throughout every step of the journey, ensuring transparent communication, timely delivery, and exceptional service that builds long-lasting partnerships.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Work With Us?</h2>
          <p className="text-xl text-gray-300 mb-10">
            Let's discuss how Afriq Global can help you achieve your digital and travel goals
          </p>
          <Link 
            to="/contact" 
            className="inline-block px-10 py-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get in Touch
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
